import api from "./api";

export const getAllJobOffers = (language) =>
  api.get(`/recruitment/joboffers?language=${language}`);

export const getJobOffer = (path) => {
  return () => api.get(`/recruitment/joboffer/${path}`);
};

export const getAllJobDegrees = () => {
  return () => api.get(`/recruitment/jobapplicationdegrees`);
};

export const getAllJobLocations = () => {
  return () => api.get(`/recruitment/joblocations`);
};

export const getAllJobAreas = () => {
  return () => api.get(`/recruitment/jobapplicationareasofinterest`);
};

export const postSpontaneousApplication = async (formData) => {
  return api.post("/recruitment/spontaneousapplication", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const postJobOfferApplication = async (path, formData) => {
  return api.post(`/recruitment/jobofferapplication/${path}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
